import { massFilter } from "./mass_filter.js";
/**
 * Given a list of ranges with ms, returns the weighted mass times abundance.
 * @param ranges
 * @param options
 * @returns List of mass and weighted mass times abundance objects
 */
export function vectorify(ranges, options = {}) {
    const { massPower = 3, intPower = 0.6 } = options;
    const filter = options.thresholdFactor || options.maxNumberPeaks || options.groupWidth;
    const vector = new Array(ranges.length);
    if (filter) {
        const filterOptions = {
            thresholdFactor: options.thresholdFactor,
            maxNumberPeaks: options.maxNumberPeaks,
            groupWidth: options.groupWidth,
        };
        for (let i = 0; i < ranges.length; ++i) {
            const len = ranges[i].ms.x.length;
            vector[i] = {
                x: ranges[i].ms.x,
                y: new Array(len),
            };
            for (let j = 0; j < len; ++j) {
                vector[i].y[j] =
                    ranges[i].ms.x[j] ** massPower * ranges[i].ms.y[j] ** intPower;
            }
            vector[i] = massFilter(vector[i], filterOptions);
        }
    }
    else {
        for (let i = 0; i < ranges.length; ++i) {
            const len = ranges[i].ms.x.length;
            vector[i] = {
                x: ranges[i].ms.x,
                y: new Array(len),
            };
            for (let j = 0; j < len; ++j) {
                vector[i].y[j] =
                    ranges[i].ms.x[j] ** massPower * ranges[i].ms.y[j] ** intPower;
            }
        }
    }
    return vector;
}
//# sourceMappingURL=vectorify.js.map